import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCommentCheck = () => {
  return (
    <g>
      <path d="m6.252 0 3.507.004a.75.75 0 0 1 .1 1.495l-.102.007L6.265 1.5l-.212.004A4.753 4.753 0 0 0 6.033 11l.218.005H8a.75.75 0 0 1 .743.648l.007.102v2.298l1.226-.59a7.996 7.996 0 0 0 4.519-6.917l.005-.288a.75.75 0 1 1 1.5 0 9.498 9.498 0 0 1-5.102 8.422l-.271.136-2.302 1.109a.75.75 0 0 1-1.068-.575l-.007-.102v-2.742h-1A6.253 6.253 0 0 1 .005 6.479L0 6.249A6.25 6.25 0 0 1 5.78.019L6.01.004 6.252 0zm9.53.718a.72.72 0 0 1 .07.955l-.073.082-7.263 7.033a.766.766 0 0 1-.98.067l-.083-.071-3.234-3.18a.72.72 0 0 1 .004-1.037.766.766 0 0 1 .979-.068l.084.072L7.99 7.23 14.72.714a.765.765 0 0 1 1.063.004z" />
    </g>
  );
};

export default withIcon(IconCommentCheck);
